import { gql } from "@stadium/services/apollo-client";

export const BUNDLE_PRODUCT_DETAILS = gql`
  fragment BundleProductDetails on BundleProduct {
    id
    quantity
    catalogType
    bundleId
    productId
    collectionId
    productType
    variant {
      externalId
    }
    vendor {
      externalId
    }
    brand {
      name
    }
    catalog {
      number
      store {
        externalId
      }
    }
  }
`;
